// Generated by `npm run small-rules` (scripts/small-rules.ts) — do not edit by hand.
//
// Every clean rule, but each family's full subset, whose lines all stay short:
// no circuit, tail or edge line over 64 steps on a level-4 board, and the same
// on level 5 (so it never grows). Value: its longest strand, in steps.
// Keyed like `describeRule`.

export const SMALL_RULES: Readonly<Record<string, Readonly<Record<string, number>>>> = {
  hex: {
    '15 · 000000000': 3,
    '258 · 000000000': 4,
    '15 · 000010010': 6,
    '258 · 001000000': 6,
    '258 · 000100000': 7,
    '258 · 010000000': 7,
    '258 · 010100000': 7,
    '128 · 011110001': 8,
    '15 · 000000010': 9,
    '15 · 000010000': 9,
    '258 · 000000100': 9,
    '258 · 000010000': 9,
    '258 · 001000100': 9,
    '258 · 001010000': 9,
    '258 · 010010000': 9,
    '258 · 001100000': 10,
    '258 · 010000100': 10,
    '258 · 011000000': 10,
    '128 · 001110001': 11,
    '128 · 010110001': 11,
    '258 · 000010100': 13,
    '258 · 001010100': 13,
    '258 · 010010100': 13,
    '258 · 011000100': 13,
    '258 · 011010000': 13,
    '128 · 001010001': 14,
    '128 · 001100001': 14,
    '128 · 010100001': 14,
    '128 · 011010001': 14,
    '128 · 011100001': 14,
    '258 · 011100000': 14,
    '128 · 010010001': 17,
    '258 · 000110000': 17,
    '258 · 001110000': 17,
    '258 · 010110000': 17,
    '258 · 011110000': 17,
    '258 · 000000010': 18,
    '258 · 000100010': 18,
    '258 · 001000010': 18,
    '258 · 001100010': 18,
    '258 · 010000010': 18,
    '258 · 010100010': 18,
    '258 · 011000010': 18,
    '258 · 011100010': 18,
    '128 · 000110001': 19,
    '128 · 011110000': 19,
    '258 · 011010100': 19,
    '258 · 011110110': 20,
    '258 · 000010010': 24,
    '258 · 010010010': 24,
    '128 · 000100001': 25,
    '258 · 000100100': 26,
    '128 · 000110000': 27,
    '258 · 001010010': 27,
    '128 · 000010001': 28,
    '258 · 000110110': 29,
    '258 · 001100100': 29,
    '258 · 010100100': 29,
    '128 · 001110000': 30,
    '128 · 010110000': 30,
    '258 · 011010010': 31,
    '258 · 001110110': 32,
    '258 · 010110110': 32,
    '258 · 000110010': 35,
    '258 · 010110010': 35,
    '258 · 001110010': 38,
    '258 · 011110010': 42,
    '258 · 000110100': 57,
    '258 · 001110100': 60,
    '258 · 010110100': 60,
  },
  spectre: {
    '15 · 0000000000': 3,
    '2578 · 0000000000': 5,
    '15 · 0000100100': 6,
    '2578 · 0010000000': 7,
    '2578 · 0001000000': 8,
    '1278 · 0111100001': 9,
    '15 · 0000000100': 9,
    '15 · 0000100000': 9,
    '2578 · 0000100000': 9,
    '2578 · 0100000000': 9,
    '2578 · 0100100000': 9,
    '2578 · 0101000000': 9,
    '2578 · 0010100000': 10,
    '2578 · 0000001000': 11,
    '2578 · 0010001000': 11,
    '1278 · 0011100001': 12,
    '1278 · 0101100001': 12,
    '2578 · 0011000000': 12,
    '2578 · 0100001000': 12,
    '2578 · 0110000000': 12,
    '2578 · 0000101000': 14,
    '2578 · 0010101000': 14,
    '1278 · 0010100001': 15,
    '1278 · 0011000001': 15,
    '1278 · 0101000001': 15,
    '1278 · 0110100001': 15,
    '1278 · 0111000001': 15,
    '2578 · 0100101000': 15,
    '2578 · 0110001000': 15,
    '2578 · 0110100000': 15,
    '2578 · 0111000000': 17,
    '1278 · 0100100001': 18,
    '2578 · 0000000100': 18,
    '2578 · 0001000100': 18,
    '2578 · 0010000100': 18,
    '2578 · 0011000100': 18,
    '2578 · 0100000100': 18,
    '2578 · 0101000100': 18,
    '2578 · 0110000100': 18,
    '2578 · 0111000100': 18,
    '2578 · 0001100000': 19,
    '2578 · 0011100000': 19,
    '2578 · 0101100000': 19,
    '2578 · 0111100000': 20,
    '1278 · 0001100001': 21,
    '1278 · 0111100000': 21,
    '2578 · 0110101000': 21,
    '2578 · 0111101100': 22,
    '2578 · 0000100100': 24,
    '2578 · 0100100100': 24,
    '1278 · 0001000001': 27,
    '2578 · 0010100100': 28,
    '1278 · 0001100000': 29,
    '1278 · 0000100001': 30,
    '2578 · 0001001000': 30,
    '2578 · 0001101100': 31,
    '1278 · 0011100000': 33,
    '1278 · 0101100000': 33,
    '2578 · 0110100100': 33,
    '2578 · 0011001000': 34,
    '2578 · 0101001000': 34,
    '2578 · 0011101100': 35,
    '2578 · 0101101100': 35,
    '2578 · 0001100100': 38,
    '2578 · 0101100100': 38,
    '2578 · 0011100100': 42,
    '2578 · 0111100100': 47,
    '2578 · 0001101000': 63,
  },
};
